import { z } from "zod";

import { apiGetList, apiMutate } from "@/lib/api/client";

const notificationSchema = z.object({
  id: z.string(),
  category: z.string(),
  eventType: z.string(),
  title: z.string(),
  message: z.string(),
  metadata: z.record(z.string(), z.unknown()),
  actionType: z.string().nullable(),
  actionLabel: z.string().nullable(),
  actionPayload: z.record(z.string(), z.unknown()).nullable(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});

export type Notification = z.infer<typeof notificationSchema>;

export async function fetchNotifications(signal?: AbortSignal): Promise<Notification[]> {
  const response = await apiGetList<unknown>(
    "/auth/notifications",
    { filters: { category: "all" } },
    signal,
  );
  return z.array(notificationSchema).parse(response.data);
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  await apiMutate<unknown>("POST", "/auth/notifications/read", {
    body: { notificationId },
    idempotencyKey: crypto.randomUUID(),
  });
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiMutate<unknown>("POST", "/auth/notifications/read-all", {
    body: undefined,
    idempotencyKey: crypto.randomUUID(),
  });
}
